<template>
  <div class="tenant_info_area" id="tenant_info">
    <div class="edit_area_half">
      <valueLabelSection
        :titleLabel="companyIdLabel"
        :valueLabel="corporation.companyId"
      ></valueLabelSection>
      <inputBindSection
        :titleLabel="companyNameLabel"
        :bindValue="getDisplayValue('companyName')"
        @inputUpdate="inputUpdate('companyName')"
      ></inputBindSection>
      <checkBoxBindSection
        :titleLabel="mailTargetFlagLabel"
        :nameValue="mailTargetFlag"
        :checked="getDisplayValue('mailTargetFlag')"
      ></checkBoxBindSection>
    </div>
    <div class="edit_area_half">
      <!-- 更新対象の管理ユーザを特定するために古い管理ユーザID固定 -->
      <inputBindSection
        :titleLabel="adminUserIdLabel"
        :bindValue="getDisplayValue('adminUsers.0.adminUserId')"
        @inputUpdate="inputUpdate('adminUserId')"
      ></inputBindSection>
      <inputBindSection
        :titleLabel="adminUserNameLabel"
        :bindValue="getDisplayValue('adminUsers.0.adminUserName')"
        @inputUpdate="inputUpdate('adminUserName')"
      ></inputBindSection>
      <inputBindSection
        :titleLabel="mailAddressLabel"
        :bindValue="getDisplayValue('adminUsers.0.mailAddress')"
        @inputUpdate="inputUpdateMail('mailAddress')"
      ></inputBindSection>
      <div class="detail_label">
        {{ passwordLabel }}
      </div>
      <div class="password_change">
        <input
          type="button"
          :value="passwordChangeButton"
          class="password_change_button"
          @click="$emit('clickPasswordChangeButton')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import inputBindSection from './inputBindSection.vue'
import checkBoxBindSection from './checkBoxBindSection.vue'
import valueLabelSection from './valueLabelSection.vue'

export default {
  data() {
    return {
      companyIdLabel: 'テナントID',
      companyNameLabel: 'テナント名',
      GpsEnableFlagLabel: 'GPS情報機能の使用有無',
      adminUserIdLabel: '管理者ID',
      adminUserNameLabel: '管理者名',
      mailAddressLabel: 'メールアドレス',
      passwordLabel: '管理者パスワード',
      passwordChangeButton: 'パスワード変更',
      locationInfoEnableFlag: 'location_info_enable',
      gpsEnableFlag: 'gps_enable',
      mailTargetFlagLabel: '警告メール送信の使用有無',
      mailTargetFlag: 'mail_target'
    }
  },
  components: {
    inputBindSection,
    checkBoxBindSection,
    valueLabelSection
  },
  computed: {
    corporation() {
      return this.$store.state.corporations.corporation
    },
    updateCorporation() {
      return this.$store.state.corporations.updateCorporation
    }
  },
  methods: {
    inputUpdate(e) {
      this.$store.dispatch('corporations/inputUpdate', {
        name: e,
        value: event.target.value
      })
    },
    inputUpdateAdminUser(e) {
      this.$store.dispatch('corporations/inputUpdateAdminUser', {
        name: e,
        value: event.target.value
      })
    },
    inputUpdateMail(e) {
      this.inputUpdate(e)
      this.inputUpdateAdminUser(e)
    },
    getDisplayValue(path) {
      const getValueByPath = (obj, path) => {
        return path
          .split('.')
          .reduce(
            (acc, key) =>
              acc && acc[key] !== undefined ? acc[key] : undefined,
            obj
          )
      }
      const aliasMap = {
        'adminUsers.0.adminUserId': 'adminUserId',
        'adminUsers.0.adminUserName': 'adminUserName'
      }
      const inputPath = aliasMap[path] || path
      const updateValue = getValueByPath(this.updateCorporation, inputPath)
      const baseValue = getValueByPath(this.corporation, path)
      return updateValue !== undefined && updateValue !== null
        ? updateValue
        : baseValue
    }
  }
}
</script>

<style scoped>
.password_change {
  height: 40px;
}
.system_user_password_label {
  padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporationComponents/tenantEditInfo.vue